import { Button } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { Box } from '../UI/index';

const profiles = [
	{
		value: 0,
		label: 'Core+ Office Central London',
		location: 'EC1N',
		status: 'Auction',
		class: 'Core+',
		subClass: 'Multi-tenant',
		glaMin: 7,
		glaMax: 8,
		askingPriceMin: 80,
		askingPriceMax: 90,
		city: 'london',
		center: {
			lat: 51.517708,
			lng: -0.107643,
		},
	},
	{
		value: 1,
		label: 'Core+ Office Berlin',
		location: '10589',
		status: 'Silent',
		class: 'Core',
		subClass: 'Single-tenant',
		glaMin: 10,
		glaMax: 15,
		askingPriceMin: 70,
		askingPriceMax: 100,
		city: 'berlin',
		center: {
			lat: 52.523695,
			lng: 13.306536,
		},
	},
	{
		value: 2,
		label: 'Office Amsterdam',
		location: '1011 BA',
		status: 'Auction',
		class: 'Core+',
		subClass: 'Industrial',
		glaMin: 23,
		glaMax: 24,
		askingPriceMin: 105,
		askingPriceMax: 110,
		city: 'amsterdam',
		center: {
			lat: 52.373557,
			lng: 4.906026,
		},
	},
];

export default function Search({ handleFilterChange }) {
	const classes = useStyles();
	const [profile, setProfile] = React.useState(0);
	const [activeProfile, setActiveProfile] = React.useState(profiles[1]);

	React.useEffect(() => {
		setActiveProfile(profiles[profile]);
	}, [profile]);

	const handleProfileChange = event => {
		setProfile(event.target.value);
		handleFilterChange(profiles[event.target.value].city, profiles[event.target.value].center);
	};
	const handleValueChange = event => {
		setActiveProfile({
			...activeProfile,
			[event.target.name]: event.target.value,
		});
	};

	return (
		<Box width="400px" p="15px">
			<TextField
				select
				label="Saved search profiles"
				value={profile}
				onChange={handleProfileChange}
				variant="outlined"
				className={classes.input}
			>
				{profiles.map(option => (
					<MenuItem key={option.value} value={option.value}>
						{option.label}
					</MenuItem>
				))}
			</TextField>
			<Divider className={classes.divider} />
			<TextField
				label="Location/Postcode"
				variant="outlined"
				className={classes.input}
				value={activeProfile.location}
				name="location"
				onChange={handleValueChange}
			/>
			<TextField
				select
				label="aXcess Status"
				value={activeProfile.status}
				onChange={handleValueChange}
				variant="outlined"
				className={classes.input}
				name="status"
			>
				<MenuItem value="Auction">Auction</MenuItem>
				<MenuItem value="Silent">Silent</MenuItem>
			</TextField>
			<TextField
				select
				label="Asset Class"
				value={activeProfile.class}
				onChange={handleValueChange}
				variant="outlined"
				className={classes.input}
				name="class"
			>
				<MenuItem value="Core">Core</MenuItem>
				<MenuItem value="Core+">Core+</MenuItem>
				<MenuItem value="Value Add">Value Add</MenuItem>
			</TextField>
			<TextField
				select
				label="Asset Sub-Class"
				value={activeProfile.subClass}
				onChange={handleValueChange}
				variant="outlined"
				className={classes.input}
				name="subClass"
			>
				<MenuItem value="Co-Working">Co-Working</MenuItem>
				<MenuItem value="Single-tenant">Single-tenant</MenuItem>
				<MenuItem value="Multi-tenant">Multi-tenant</MenuItem>
				<MenuItem value="Cross-Docks">Cross-Docks</MenuItem>
				<MenuItem value="Warehouse">Warehouse</MenuItem>
				<MenuItem value="Industrial">Industrial</MenuItem>
			</TextField>
			<Box display="flex" justifyContent="space-between">
				<TextField
					label="GLA (min)"
					value={activeProfile.glaMin}
					name="glaMin"
					variant="outlined"
					className={classes.inputSmall}
					InputProps={{
						endAdornment: <InputAdornment position="end">k sqm</InputAdornment>,
					}}
					onChange={handleValueChange}
				/>
				<TextField
					label="GLA (min)"
					value={activeProfile.glaMax}
					name="glaMax"
					variant="outlined"
					className={classes.inputSmall}
					InputProps={{
						endAdornment: <InputAdornment position="end">k sqm</InputAdornment>,
					}}
					onChange={handleValueChange}
				/>
			</Box>

			<Box display="flex" justifyContent="space-between">
				<TextField
					label="Asking Price (min)"
					value={activeProfile.askingPriceMin}
					name="askingPriceMin"
					variant="outlined"
					className={classes.inputSmall}
					InputProps={{
						startAdornment: <InputAdornment position="start">£</InputAdornment>,
						endAdornment: <InputAdornment position="end">m</InputAdornment>,
					}}
					onChange={handleValueChange}
				/>
				<TextField
					label="Asking Price (min)"
					value={activeProfile.askingPriceMax}
					name="askingPriceMax"
					variant="outlined"
					className={classes.inputSmall}
					InputProps={{
						startAdornment: <InputAdornment position="start">£</InputAdornment>,
						endAdornment: <InputAdornment position="end">m</InputAdornment>,
					}}
					onChange={handleValueChange}
				/>
			</Box>
			<Divider className={classes.divider} />
			<Button variant="contained" className={classes.button}>
				Location Research
			</Button>
			<Button variant="contained" className={classes.button} onClick={() => setProfile(0)}>
				Clear Search
			</Button>
			<Button variant="contained" color="primary" className={classes.button}>
				Search
			</Button>
		</Box>
	);
}

const useStyles = makeStyles(theme => ({
	input: {
		width: '100%',
		marginTop: '.5rem',
		background: 'white',
	},
	inputSmall: {
		width: '49%',
		marginTop: '.5rem',
		background: 'white',
	},
	divider: {
		marginTop: '1rem',
		marginBottom: '.5rem',
	},
	button: {
		marginTop: '.5rem',
		width: '100%',
	},
}));
